import { ResolverTag } from '@ps/web-core-enums';
import React, { Suspense } from 'react';

import LoadingIndicator from '@swf/components/LoadingIndicator/LoadingIndicator';
import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import Translation from '@swf/components/Translation/Translation';
import useImagePreloader from '@swf/core/hooks/useImagePreloader';

import backgroundImage from '../../assets/fb-maintenance.jpg';
import foxbet from '../../assets/foxbet-logo-maintenance.png';

import {
  TXTCLI_For_urgent_requests_contact_Xa_ELL,
  TXTCLI_Our_ApologiesX,
  TXTCLI_Our_site_is_currently_under_ma_ELL,
  TXTCLI_Thank_you_for_your_patienceX
} from './FoxBet.messages.json';
import styles from './FoxBet.scss';

const FoxBet: React.FC = () => {
  const { imagesPreloaded } = useImagePreloader([backgroundImage]);

  const loader = <LoadingIndicator loading variant="light" className={styles.loading} />;

  return imagesPreloaded ? (
    <Suspense fallback={loader}>
      <div className={styles.container}>
        <img src={foxbet} alt="fox bet logo" />
        <h1 className={styles.title}>
          <Translation {...TXTCLI_Our_ApologiesX} />
        </h1>
        <p className={styles.content}>
          <Translation {...TXTCLI_Our_site_is_currently_under_ma_ELL} />
        </p>
        <p className={styles.content}>
          <Translation
            values={{
              a: (msg: string) => (
                <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
              )
            }}
            {...TXTCLI_For_urgent_requests_contact_Xa_ELL}
          />{' '}
          <Translation tagName={'span'} {...TXTCLI_Thank_you_for_your_patienceX} />
        </p>
      </div>
    </Suspense>
  ) : (
    loader
  );
};

export default FoxBet;
